import { Box, ListItem, ListItemText } from '@mui/material';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { SECURITY_FALLBACKS } from '../../../../../../../corelogic/domain/constants/displayFallbacks.constants';
import { UserTotalPoints } from '../../../../../../../corelogic/domain/models/userSeason.model';
import { CODE_TO_COUNTRY } from '../../../../../../../corelogic/domain/utils/country.utils';
import { SafeText } from '../../../../../../../corelogic/domain/utils/xssProtection.utils';
import { HubCircularImage } from '../HubCircularImage/HubCircularImage';

interface UserRankedListItemProps {
  index: number;
  user: UserTotalPoints;
  rankIcon?: React.ReactNode;
}

const UserRankedListItem: React.FC<UserRankedListItemProps> = ({
  index,
  user,
  rankIcon,
}) => {
  const countryName = CODE_TO_COUNTRY[user.nationality];
  const showFlag = !!countryName; // Only show flag if country name is known

  return (
    <ListItem>
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}
      >
        <Box
          sx={{
            minWidth: 32,
            maxWidth: 32,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {rankIcon}
        </Box>
        <ListItemText
          primary={
            <React.Fragment>
              <SafeText
                text={user.username}
                fallback={SECURITY_FALLBACKS.USERNAME}
              />
              {showFlag && (
                <Box
                  component="span"
                  sx={{
                    display: 'inline-block',
                    marginLeft: '10px',
                    border: '1px solid rgba(255,255,255,0.2)',
                    borderRadius: '2px',
                    overflow: 'hidden',
                    verticalAlign: 'middle',
                    width: '24px',
                    height: '16px',
                  }}
                >
                  <ReactCountryFlag
                    countryCode={user.nationality}
                    svg
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'block',
                      objectFit: 'cover',
                    }}
                    title={countryName}
                  />
                </Box>
              )}
            </React.Fragment>
          }
          secondary={
            <Box component="span" sx={{ fontWeight: 'bold', color: '#cc0000' }}>
              {user.totalPoints} points
            </Box>
          }
          sx={{
            textAlign: 'left',
            flex: 1,
            '& .MuiListItemText-primary': {
              fontSize: { xs: '0.9rem', sm: 'clamp(0.6rem, 2.2vw, 0.9rem)' },
              fontWeight: 'normal',
              fontStyle: index < 3 ? 'italic' : 'normal',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            '& .MuiListItemText-secondary': {
              fontSize: { xs: '0.8rem', sm: 'clamp(0.5rem, 2.0vw, 0.8rem)' },
              color: 'rgba(255, 255, 255, 0.7)',
            },
          }}
        />
        <HubCircularImage
          isLoading={false}
          imageSrc={user.profilePicture}
          size={40}
        />
      </Box>
    </ListItem>
  );
};

export default UserRankedListItem;
